import { useEffect, useRef, useState } from "react";
import { ArrowIcon } from "../../components/ArrowIcon";

export function InstallCommand({ tool }: { tool: "omacam" | "contcam" | "omawisper" }) {
  const [copyState, setCopyState] = useState<"idle" | "copied" | "select">("idle");
  const commandRef = useRef<HTMLElement>(null);
  const copyTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const installerPath = `/tools/${tool}/install.sh`;
  const tokens = [
    { kind: "command", text: "curl" },
    { kind: "flag", text: " -fsSL " },
    { kind: "url", text: `${window.location.origin}${installerPath}` },
    { kind: "operator", text: " | " },
    { kind: "command", text: "bash" },
  ];
  const command = tokens.map(token => token.text).join("");

  useEffect(() => () => {
    if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
  }, []);

  const copyCommand = async () => {
    if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
    try {
      await navigator.clipboard.writeText(command);
      setCopyState("copied");
      copyTimerRef.current = setTimeout(() => setCopyState("idle"), 2500);
    } catch {
      if (commandRef.current) {
        const range = document.createRange();
        range.selectNodeContents(commandRef.current);
        const selection = window.getSelection();
        selection?.removeAllRanges();
        selection?.addRange(range);
        commandRef.current.focus();
      }
      setCopyState("select");
    }
  };

  return <>
    <div className="oc-command-box">
      <div className="oc-command-heading">
        <span>Omarchy terminal</span>
        <button type="button" className="oc-copy-command" onClick={copyCommand}>
          {copyState === "copied" ? "Copied" : "Copy command"}
          <svg width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" /><path d="M12 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h2" /></svg>
        </button>
      </div>
      <pre><code ref={commandRef} className="language-bash" tabIndex={0}>{tokens.map((token, index) => <span key={index} className={`oc-code-${token.kind}`}>{token.text}</span>)}</code></pre>
    </div>
    <span className={copyState === "select" ? "oc-copy-feedback" : "oc-sr-only"} role="status">{copyState === "copied" ? "Install command copied." : copyState === "select" ? "Command selected. Copy it with your keyboard or selection menu." : ""}</span>
    <p className="oc-small"><a href={installerPath} download={`${tool}-install.sh`}><span>Read the install script</span><ArrowIcon direction="upRight" /></a></p>
  </>;
}
